import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import templateAPIs from '../../../api/services/template.service';

const initialState = {
  value: [],
};
interface MyData {
  billingId: any;
}
export const getAppointmentDetailsCall = createAsyncThunk(
  'getAppointmentDetails',
  async (payload: MyData, { rejectWithValue }) => {
    try {
      const res = await templateAPIs.getAppointmentDetails(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
const getAppointmentDetails = createSlice({
  name: 'getAppointmentDetails',
  initialState,
  reducers: {
    savingGetTemplateData: (state, action) => {
      state.value = { ...action.payload };
    },
    clearAppointmentDetail: state => {
      state.value = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAppointmentDetailsCall.pending, () => {})
      .addCase(getAppointmentDetailsCall.fulfilled, (state: any, action) => {
        state.value = action.payload;
      })
      .addCase(getAppointmentDetailsCall.rejected, () => {});
  },
});
// Action creators are generated for each case reducer function
export const { savingGetTemplateData, clearAppointmentDetail } = getAppointmentDetails.actions;
export default getAppointmentDetails.reducer;
